/**
 * Created by lency on 9/20/16.
 */
export default () => {
    return function (scope, elem, attrs) {

        elem.on('mouseenter.ybdropdown', (e) => {

            e.preventDefault();
            e.stopPropagation();
            let $toggle = $(e.currentTarget);
            $toggle.addClass('active');
        }).on('mouseleave.ybdropdown',(e)=>{
            e.preventDefault();
            e.stopPropagation();
            let $toggle = $(e.currentTarget);
            $toggle.removeClass('active');
        });
        let $toggle;
        elem.on('touchstart', (e) => {
            e.stopPropagation();
            $toggle= $(e.currentTarget);
            $toggle.addClass('active');
            $('body').on('touchstart',()=>{
                $toggle.removeClass('active');
            })
        })

    };
};



// WEBPACK FOOTER //
// ./src/app/common/navbar/directives/yb-drop-down.js